<template>
  <header id="heroheader">
    <div class="header-img">
      <img class="himg" src="@/assets/images/header-img.jpg" @load="imgload" />
    </div>
    <div class="header-tx">
      <h2><img src="@/assets/images/mainlogo.svg" alt="天聖閣" /></h2>
      <div class="saijo">
        <ul>
          <li>本渡斎場</li>
          <li>五和斎場</li>
          <li>苓北斎場</li>
        </ul>
      </div>
      <h3>
        <span>故人を偲ぶ想いを</span>
        <span>安心と信頼で―</span>
      </h3>
      <router-link class="contact-btn" to="contact">
        <span>今すぐご相談</span>
        <span>24時間365日承ります</span>
      </router-link>
    </div>
  </header>
</template>

<script>
import gsap from "gsap";
export default {
  methods: {
    imgload() {
      document.getElementById("heroheader").classList.add("loaded");
      gsap
        .timeline({ repeat: 0 })
        .to(".header-img", { opacity: 1, filter: "blur(0px)", duration: 2 }, 0)
        .fromTo(
          ".himg",
          { scale: 1.2 },
          { scale: 1, ease: "none", duration: 5 },
          0
        )
        .fromTo(".header-tx", { opacity: 0 }, { opacity: 1 }, "1");
    },
  },
};
</script>

<style lang="scss" scoped>
#heroheader {
  padding-top: 145px;
  position: relative;
  height: 100vh;
  @include tb {
    padding-top: 80px;
  }
  .header-img {
    position: absolute;
    overflow: hidden;
    width: 100%;
    height: calc(100% - 145px);
    opacity: 0;
    filter: blur(10px);
    @include tb {
      height: calc(100% - 80px);
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      filter: brightness(0.6);
    }
  }
  .header-tx {
    position: absolute;
    display: flex;
    width: 100%;
    height: calc(100% - 145px);
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: $h-gap;
    color: white;
    text-align: center;
    opacity: 0;
    h2 {
      width: 65vw;
      max-width: 420px;
      min-width: 240px;
      margin-bottom: 2rem;
    }
    h3 {
      font-size: clamp(1.5rem, 3vw, 3.5rem);
      margin-bottom: 2rem;
      span {
        display: inline-block;
      }
    }
    .saijo {
      ul {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 0.5rem;
        margin-bottom: 2rem;
        li {
          font-size: clamp(1rem, 3vw, 1.5rem);
          text-align: center;
          position: relative;
          background-color: $color-hondo;
          padding: 0.35em 1em;
          color: white;
          z-index: 0;
          @include dogear(0.75rem);
          &:nth-child(2) {
            background-color: $color-itsuwa;
          }

          &:nth-child(3) {
            background-color: $color-reihoku;
          }
        }
      }
      p {
        font-size: 0.875rem;
      }
    }
    .contact-btn {
      background-color: rgba(0, 0, 0, 0.5);
      max-width: 420px;
      width: 80vw;
      display: block;
      padding: 1rem;
      position: relative;
      z-index: 0;
      @include tb {
        display: none;
      }
      span {
        display: block;
        &:nth-child(1) {
          font-size: 1.5rem;
          margin-bottom: 0.25em;
          @include tb {
            font-size: 1.25rem;
          }
        }
        &:nth-child(2) {
        }
      }
      &::before,
      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 1px solid white;
        z-index: 1;
      }
      &::before {
        width: calc(100% - 0.5rem);
        left: 0.25rem;
      }
      &::after {
        height: calc(100% - 0.5rem);
        top: 0.25rem;
      }
    }
  }
}
</style>
